import { render, staticRenderFns } from "./PuzzleNumberSquareForm.vue?vue&type=template&id=09b385ab"
import script from "./PuzzleNumberSquareForm.vue?vue&type=script&lang=js"
export * from "./PuzzleNumberSquareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports